import { makeStyles } from '@material-ui/core';
import themes from 'styles/themes';

export const useStyles = makeStyles(() => ({
    main: {
        height: '100%',
    },
    searchForm: {
        marginTop: 0,
        top: 56,
        position: 'absolute',
        left: 0,
        right: 0,
        padding: '18px 24px 0 ',
        '@media (max-width: 1024px)': {
            position: 'fixed',
        },
    },
    searchIcon: {
        position: 'absolute',
        left: 10,
        top: 2,
        color: 'white',
    },

    input: {
        padding: '10px 0 10px 30px',
        background: 'transparent',
        border: 'none',
        borderBottom: '1px solid #4a6c72 ',
        color: 'white',
        fontSize: 14,
        position: 'relative',
    },
    filter: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 24px',
        // marginBottom: 10
    },
    chipOutline: {
        border: '1px solid #4A6C72',
    },
    chipLabel: {
        padding: '0 8px',
        color: themes.palette.primary.main,
        fontFamily: 'PoppinsRegular',
        fontSize: 12,
        fontWeight: 600,
    },
    chipIcon: {
        color: 'white',
    },
    buttonsWrapper: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItem: 'center',
        overflowX: 'scroll',
        '& button': {
            border: '1px solid',
            backgroundColor: 'transparent',
            borderRadius: 71,
            color: themes.palette.primary.main,
            fontSize: 14,
            padding: '5px 8px',
            margin: '8px 4px',
            whiteSpace: 'nowrap',
        },
    },
    filterConsumersWrapper: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItem: 'center',
        overflowX: 'scroll',
        marginBottom: '8px',
    },
    activeButton: {
        backgroundColor: `${themes.palette.primary.main} !important`,
        color: `${themes.palette.common.white} !important`,
        border: 'none',
    },
    chipOutlineConsumers: {
        border: `1px solid ${themes.palette.primary.main}`,
        marginRight: '6px',
        marginLeft: '6px',
        maxWidth: '180px',
    },
    chipLabelActive: {
        padding: '0 8px',
        color: `${themes.palette.common.white}`,
        fontFamily: 'PoppinsRegular',
        fontSize: 12,
        fontWeight: 600,
    },
    chipIconActive: {
        color: `${themes.palette.common.white}`,
    },
    chipActive: {
        backgroundColor: themes.palette.primary.main,
        '&.MuiChip-clickable.MuiChip-outlined:hover': {
            backgroundColor: `${themes.palette.primary.main} !important`,
        },
        '&.MuiChip-clickable.MuiChip-outlined:focus': {
            backgroundColor: `${themes.palette.primary.main} !important`,
        },
    },
}));
